/// <amd-module name="typeahead/core/geolocation/HsrpGeolocationViewController" />
/// <amd-dependency path="typeahead/core/loc" name="loc"/>
import {ClientHandlerRegistry, IHsrpSubmitData} from "typeahead/client/ClientHandlerRegistry";
import {GeolocationDataProvider} from "typeahead/core/geolocation/GeolocationDataProvider";
import {GeolocationSuggestion} from "typeahead/core/geolocation/GeolocationSuggestion";
import {GeolocationViewController} from "typeahead/core/geolocation/GeolocationViewController";
import {GeolocationClearedMessage} from "typeahead/core/geolocation/message/GeolocationClearedMessage";
import {TypeaheadMessage} from "typeahead/core/message/TypeaheadMessage";
import {ISuggestionResult} from "typeahead/core/Suggestion";
import * as SuggestionFactory from "typeahead/core/SuggestionFactory";

export class HsrpGeolocationViewController extends GeolocationViewController {

    private static readonly ORIGIN_SUBMIT_SEARCH_WIZARD: string = "submitSearchWizard";
    private geolocationLatLong: string;
    private isGeolocationExpired: boolean = true;

    constructor(protected geolocationDataProvider: GeolocationDataProvider) {
        super(geolocationDataProvider);
        uitk.subscribe(ClientHandlerRegistry.HSR_SUBMIT_GET_QUERY_MESSAGE,
            (topic: string, submitObject: IHsrpSubmitData) => {
                this.setLatLongForCurrentLocation(submitObject);
            });

        TypeaheadMessage.subscribe(GeolocationClearedMessage.getTopic(),
            (topic: string, message: GeolocationClearedMessage) => {
                this.isGeolocationExpired = true;
            });
    }

    public handlePageLoad(): void {
        // Do nothing
    }

    protected isGeolocationAvailable(): boolean {
        return !this.isGeolocationExpired;
    }

    protected updateSearchParameters(suggestionResult: ISuggestionResult, $element: JQuery) {
        let suggestion: GeolocationSuggestion = SuggestionFactory.createSuggestion(suggestionResult);
        this.geolocationLatLong = suggestion.getLatLong().orElse("");
        this.isGeolocationExpired = false;
    }

    private setLatLongForCurrentLocation(submitObject: IHsrpSubmitData) {
        if (this.isDestinationCurrentLocation() && this.geolocationLatLong) {
            $("#latLong").val(this.geolocationLatLong);
            if (submitObject.query && submitObject.query.indexOf("latLong") === -1) {
                submitObject.query += "&latLong=" + this.geolocationLatLong;
            }
            // Set distance sort if search originated from 'submit search wizard'
            if (HsrpGeolocationViewController.ORIGIN_SUBMIT_SEARCH_WIZARD === submitObject.origin) {
                $("#sort-select").val("distance");
                if (submitObject.query && submitObject.query.indexOf("sort") === -1) {
                        submitObject.query += "&sort=distance";
                }
            }
        }
    }

    private isDestinationCurrentLocation(): boolean {
        return (loc.geolocationDisplayText === $("#inpSearchNear").val());
    }
}
